import { useState, React } from "react";
import { CommonModalContext, ModalType } from "./CommonModalContext";
import SearchTagModal from "src/pages/HomePage/components/SearchedTagModal";

function CommonModalContextProvider({ children }) {
  const [modalType, setModalType] = useState(null);
  const [parentMsgId, setParentMsgId] = useState("");
  const [hashTag, setHashTag] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [tagActivityTenantId, setTagActivityTenantId] = useState("");
  const [tagId, setTagId] = useState("");
  const [isTrendingTag, setIsTrendingTag] = useState(false);
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const [onActionSuccess, setOnActionSuccess] = useState(null);

  const onOpen = (modalType, metaData) => {
    if (modalType === ModalType.SEARCH_TAG) {
      const hashTag = metaData?.hashTag || "";
      setHashTag(hashTag);
      setTenantId(metaData?.tenantId || "");
      setTagActivityTenantId(metaData?.tagActivityTenantId || "");
      setTagId(metaData?.tagId || "");
      setIsTrendingTag(!!metaData?.isTrendingTag);
      setParentMsgId(metaData?.parentMsgId || "");
      setIsActionDisabled(!!metaData?.isActionDisabled);
      setOnActionSuccess(() => metaData?.onActionSuccess);
    }
    setModalType(modalType);
  };

  const onClose = () => {
    setModalType(null);
    setHashTag("");
    setTenantId("");
    setTagActivityTenantId("");
    setTagId("");
    setIsTrendingTag(false);
    setParentMsgId("");
    setIsActionDisabled(false);
    setOnActionSuccess(null);
  };

  return (
    <CommonModalContext.Provider
      value={{
        onOpen: onOpen,
        onClose: onClose,
      }}
    >
      {children}
      {modalType === ModalType.SEARCH_TAG &&
        (hashTag || parentMsgId || (isTrendingTag && tenantId && tagId)) && (
          <SearchTagModal
            open={modalType === ModalType.SEARCH_TAG}
            hashTag={hashTag}
            onClose={onClose}
            tenantId={tenantId}
            tagActivityTenantId={tagActivityTenantId}
            tagId={tagId}
            isTrendingTag={isTrendingTag}
            parentMsgId={parentMsgId}
            isActionDisabled={isActionDisabled}
            onActionSuccess={onActionSuccess}
          />
        )}
    </CommonModalContext.Provider>
  );
}

export default CommonModalContextProvider;
